import { render, staticRenderFns } from "./SsoValidateAccount.vue?vue&type=template&id=61f3320e&scoped=true"
import script from "./SsoValidateAccount.vue?vue&type=script&lang=ts"
export * from "./SsoValidateAccount.vue?vue&type=script&lang=ts"
import style0 from "./SsoValidateAccount.vue?vue&type=style&index=0&id=61f3320e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3320e",
  null
  
)

export default component.exports